import fetch from "lib/fetch";
import type { NotificationInterface } from "types/notification";

interface ListResponse<T> {
    data: Array<T>;
    pager: {
        total: number;
        total_page: number;
        last_page: number;
        per_page: number;
        current_page: number;
        order?: string;
        direction?: string;
        custom?: HashMap<number | undefined>;
    };
    filters: HashMap<unknown>;
}

type NotificationResponse = { data: NotificationInterface };

export const getNotificationsRequest = (params?: HashMap<unknown>) =>
    fetch.get<ListResponse<NotificationInterface>>("notification", { params });

export const batchReadNotificationsRequest = (data?: unknown) =>
    fetch.put<NotificationResponse>("notification/batch_read", data);

export const deleteNotificationRequest = (id: string) =>
    fetch.delete<NotificationResponse>(`notification/${id}`);
